import * as React from "react";
import {useMemo} from "react";
import {classNames, theme, useUtilization} from "@variocube/cube-ui";
import {stylesheet} from "typestyle";
import {useLocalization} from "../../i18n";

export function UtilizationOverlay() {
    const utilization = useUtilization();
    const {t} = useLocalization();

    const {available, total} = utilization.all;

    const {loadPercentage, loadLevelStyle} = useMemo(() => {
        const loadFactor = 1 - (available / total);
        return {
            loadPercentage: Math.round(100 * loadFactor),
            loadLevelStyle: getLoadLevelStyle(loadFactor)
        };
    }, [available, total]);

    return (
        <div className={styles.utilizationOverlay}>
            <div className={styles.utilizationAvailableLockers}>{available}</div>
            {t("AvailableLockers")}
            <div className={classNames(styles.utilizationLoad)}>
                <div className={classNames(styles.loadLevel, loadLevelStyle)} style={{ width: `${loadPercentage}%`}}/>
                <div className={styles.loadText}>{loadPercentage}% {t("Occupied")}</div>
            </div>
        </div>
    )
}

function getLoadLevelStyle(loadFactor: number) {
    if (loadFactor == 1) {
        return theme.backgroundError;
    }
    else if (loadFactor > 0.8) {
        return theme.backgroundWarning;
    }
    else {
        return theme.backgroundSuccess;
    }
}

const styles = stylesheet({
    utilizationOverlay: {
        position: "absolute",
        left: "1em",
        bottom: "1em",
        textAlign: "center",
        minWidth: "9em",
        backgroundColor: "#333",
    },
    utilizationAvailableLockers: {
        fontSize: "2em",
        fontWeight: "bold",
        margin: "0.25em 0 0 0",
    },
    utilizationLoad: {
        border: "1px solid #222",
        backgroundColor: "#222",
        position: "relative",
        fontSize: "0.75em",
        textTransform: "uppercase",
        margin: "0.5em 0 0 0",
    },
    loadLevel: {
        position: "absolute",
        height: "100%",
        zIndex: 0,
    },
    loadText: {
        position: "relative",
        zIndex: 1,
        padding: "0.125em 0",
    }
});



